import React from "react";
import classes from "./refundPolicy.module.css";
import Footer from "../../components/footer";

const RefundPolicy = () => {
  return (
    <>
      <div className={classes.policyContainer}>
        <div className={classes.policyWrapper}>
          <h1>Cancellation & Refund Policy – Artist Next Door</h1>
          <p>
            <strong>Effective Date: 22nd March 2025</strong>
          </p>
          <p>
            At Artist Next Door, we aim to ensure a smooth and fair experience
            for both users and artists. Please review our cancellation and
            refund policies before booking or accepting a booking.
          </p>

          <h2>1. Artist Booking Acceptance Timeline</h2>
          <ul>
            <li>
              If the booking date is within a week, the artist must accept
              within 24 hours of the request.
            </li>
            <li>
              If the booking date is more than a week away, the artist has up to
              72 hours (3 days) to accept.
            </li>
            <li>
              Failure to accept within the required timeframe will automatically
              cancel the request, and the user will not be charged.
            </li>
          </ul>

          <h2>2. Cancellation Policy</h2>
          <h3>User-Initiated Cancellations:</h3>
          <ul>
            <li>
              If a user cancels at least 7 days before the booking date, they
              will receive a full refund.
            </li>
            <li>
              If a user cancels within 7 days of the booking date, no refund
              will be issued.
            </li>
          </ul>

          <h3>Artist-Initiated Cancellations:</h3>
          <ul>
            <li>
              If an artist cancels at any time, the user will receive a full
              refund, and the artist’s reliability rating may be impacted.
            </li>
            <li>
              No-Show Policy: If an artist fails to attend a confirmed booking
              without prior cancellation, the user will receive a full refund,
              and the artist may face penalties, including suspension from the
              platform.
            </li>
          </ul>

          <h2>3. Refund Policy</h2>
          <ul>
            <li>
              <strong>Full Refund:</strong> Users are eligible for a full refund
              if they cancel at least 7 days before the booking date or if the
              artist cancels the booking.
            </li>
            <li>
              <strong>No Refund:</strong> Cancellations made within 7 days of
              the booking date are non-refundable.
            </li>
            <li>
              <strong>Refund Processing:</strong> Refunds will be processed
              within 5-7 business days to the original payment method.
            </li>
          </ul>

          <p>
            By booking or accepting a booking on Artist Next Door, you
            acknowledge and agree to this Cancellation & Refund Policy. For any
            disputes or special requests, please contact our support team at
            <strong>
              {" "}
              <a href="mailto:support@artistnextdoor.in">
                support@artistnextdoor.in
              </a>
            </strong>
            .
          </p>

          <p>Thank you for being a part of Artist Next Door!</p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default RefundPolicy;
